import Button from "../../../common/Button"

const ControlsDelete = ({action}) => {
    return <Button click={action} btnStyle={'btn_simple'}><i className='ti ti-trash'></i>Clear Item</Button>
}

export default ControlsDelete